import React from 'react';

import {
    primaryColor,
    blackColor,
    greyColor,
    badgeContainer,
    applyHoverStyle as styles_applyHoverStyle,
} from './EventListItemBadge.scss';

import classNames from 'owa-classnames';
import { DirectionalHint, Icon, TooltipHost } from '@fluentui/react';
import LinkDismissFilled from 'owa-fluent-icons-svg/lib/icons/LinkDismissFilled';
import LinkFilled from 'owa-fluent-icons-svg/lib/icons/LinkFilled';
import {
    bookWithMePrivateBadgeTooltip,
    bookWithMeNoSharingBadgeTooltip,
} from './Shared.locstring.json';
import loc from 'owa-localize';

export enum BadgeColor {
    Primary,
    Red,
    Black,
    Grey,
}

export interface EventListItemBadgeProps {
    color: BadgeColor;
    onClick?: (evt: React.MouseEvent<HTMLDivElement>) => void;
    isDisabled: boolean;
}

export default function EventListItemBadge(props: EventListItemBadgeProps) {
    let colorClass = '';
    let lockIcon = '';
    let tooltipText = '';
    switch (props.color) {
        case BadgeColor.Primary:
            colorClass = primaryColor;
            lockIcon = LinkFilled;
            tooltipText = loc(bookWithMePrivateBadgeTooltip);
            break;
        case BadgeColor.Black:
            colorClass = blackColor;
            break;
        case BadgeColor.Grey:
            colorClass = greyColor;
            lockIcon = LinkDismissFilled;
            tooltipText = loc(bookWithMeNoSharingBadgeTooltip);
            break;
    }
    const applyHoverStyle = props.onClick != null;
    const iconStyle = { fontSize: '16px', display: 'flex' };
    const shareIcon = React.useRef<HTMLDivElement | null>(null);
    const onKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
        // handle keyboard Enter key to navigate
        if (e.key === 'Enter') {
            shareIcon.current?.click();
        }
    }, []);
    if (props.isDisabled) {
        return (
            <div
                className={classNames(badgeContainer, colorClass, {
                    [styles_applyHoverStyle]: applyHoverStyle,
                })}
                onClick={props.onClick ?? mockFunction}
                tabIndex={0}
                onKeyDown={onKeyDown}
                ref={shareIcon}
                aria-label={tooltipText}
            >
                <TooltipHost content={tooltipText} directionalHint={DirectionalHint.bottomCenter}>
                    <Icon iconName={lockIcon} style={iconStyle} />
                </TooltipHost>
            </div>
        );
    }
    /* eslint-disable-next-line react/jsx-no-useless-fragment -- (https://aka.ms/OWALintWiki)
     * Don't use react fragments if there are no children
     *	> Fragments should contain more than one child - otherwise, there’s no need for a Fragment at all. */
    return <></>;
}

function mockFunction() {
    return;
}
